<!-- src/components/Footer.vue -->
<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center mb-2">
          <div id="footer-logo" data-bs-toggle="modal" data-bs-target="#DepositModal">
            <img :src="images.logo" alt="logo" />
            <span class="font-weight-bold">Paybill: 736736</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-lg-3 mb-2">
          <div class="contacts">
            <h6>Helpline: 0111135736</h6>
            <div id="email-us">
              <a href="javascript:void(0)">Email: care@mossberg.co.ke</a>
            </div>
          </div>
          <div class="other-contacts">
            <div class="d-flex justify-content-center justify-content-md-start align-items-center">
              <div class="socialmedia">
                <a
                  href="https://wa.me/254716774776"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="whatsapp"
                  aria-label="Contact us on WhatsApp"
                >
                  <i class="bi bi-whatsapp"></i>
                </a>
                <a
                  href="https://www.facebook.com/mossbetske/"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="facebook"
                  aria-label="Follow us on Facebook"
                >
                  <i class="bi bi-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/mossbets_ke/"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="instagram"
                  aria-label="Follow us on Instagram"
                >
                  <i class="bi bi-instagram"></i>
                </a>
                <a
                  href="https://twitter.com/mossbets"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="twitter"
                  aria-label="Follow us on Twitter"
                >
                  <i class="bi bi-twitter"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-3 mb-2">
          <div class="contacts">
            <h6>Products</h6>
            <RouterLink to="/">Sports Betting</RouterLink>
            <RouterLink to="/live-games">Live betting</RouterLink>
            <RouterLink to="/league">MossLeague</RouterLink>
            <RouterLink to="/turboleague">Turbo</RouterLink>
            <RouterLink to="/jackpot">Jackpot</RouterLink>
            <RouterLink to="/instant-games">Instant Games</RouterLink>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-3 mb-2">
          <div class="contacts">
            <h6>Important information</h6>
            <RouterLink :to="{name: 'how-to-play'}">How to play</RouterLink>
            <RouterLink :to="{name: 'faqs'}">Frequently asked questions</RouterLink>
            <RouterLink :to="{name: 'terms-and-conditions'}">Terms and Conditions</RouterLink>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-3 mb-2">
          <div class="footer-details">
            <h6>License</h6>
            <p>
              Mossberg Solutions Limited Is licensed by BCLB (Betting Control and Licensing Board of
              Kenya) under the Betting Lotteries and Gaming Act, Cap 131, Laws of Kenya under
              License Number: BK-0001103
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-2">
          <div class="responsible-age">
            <span class="age-limit">18+</span>
            <h6>You must be 18 years and above to play!</h6>
          </div>
          <div class="footer-details">
            <p>
              Must be 18 years of age or older to register or play at Mossbets. Gambling may have
              adverse effects if not done with moderation.
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-2">
          <div class="footer-details">
            <h6>Responsibly Gaming Policy</h6>
            <p>
              We encourage our users to bet within their means and never chase losses. Betting
              should be a fun and controlled activity, not a source of financial stress. Please
              contact our Responsible Gambling hotline (0111135736) or for more information, please
              view our Responsibly Gaming Policy
              <RouterLink :to="{name: 'responsible-gambling'}"> here</RouterLink>
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-2">
          <div class="bottom-footer">
            <a href="www.mossbets.com">www.mossbets.com</a>
            <span>2025. All rights reserved</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { CDN } from '@/config/cdn'
const images = { logo: CDN.images('mossbets-logo.png') }
</script>
